import React, { Component } from 'react';
import { Container, Row, Col, Pagination } from 'react-bootstrap';
import PublicEvents from '../components/pubevent/PublicEvents';
import '../css/style.css';
import '../components/Home.css';
import { getURL } from '../backend/Backend';
import PublicEventShowItem from '../components/pubevent/PublicEventShowItem';



class PublicEventPagingLayout extends Component {

  constructor(props) {
    super(props);
    this.searchEvents = this.searchEvents.bind(this);
    this.pageChanged = this.pageChanged.bind(this);
    this.selectItem = this.selectItem.bind(this);
    this.goBack = this.goBack.bind(this);
    

    this.state = {
      events: [],
      selected:'',
      activePage: 1,
      totalPages: 0
    };
  }

  async componentDidMount() {
      this.searchEvents(1);
  }
  

 async pageChanged(e) {
  this.searchEvents( e.target.text);
}

  async searchEvents( page) {

    if (!page) {
      return;
    }
    if ("<" === page) {
      page = --this.state.activePage;
    }
    if (">" === page) {
      page = ++this.state.activePage;
    }
    let url = this.props.eventStatus ? `${this.props.preURL}/${this.props.id}/${this.props.eventStatus}/${page - 1}`:
        `${this.props.preURL}/${this.props.id}/${page - 1}`;
    const response = await fetch(getURL(url));
    const json = await response.json();
    let oldState = this.state;
    this.setState({
      ...oldState,
      events: json.content,
      selected:'',
      totalPages: json.totalPages,
      activePage: page
    }); 

  }

  selectItem(e){
    let oldState = this.state;
    
    this.setState({
      ...oldState,
    selected: e.id
    })
  }

   goBack(){
    let oldState = this.state;
  
    this.setState({
      ...oldState,
    selected: ''
    })
  }

  render() {
    return (
      <div >
        <Container fluid className="fluid container-fluid2">
       
          <Row className="fluid container-fluid2" >
            <Col   >
            { this.state.selected  ? 
              <PublicEventShowItem id={this.state.selected}  goBack= {this.goBack} />
              :
              <div>
                <PublicEvents events={this.state.events} selectItem={this.selectItem} edit={this.props.edit}/>
                <Pagination onClick={this.pageChanged}>
                  {this.state.activePage > 1 ?
                    <Pagination.Item>{'<'}</Pagination.Item>
                    : ""
                  }

                  {[...Array(this.state.totalPages).keys()].map(i => {
                    return <Pagination.Item active={(i + 1) === this.state.activePage} key={i} >{i + 1}</Pagination.Item>
                  })
                  }
                  {this.state.activePage < this.state.totalPages ?
                    <Pagination.Item>{'>'}</Pagination.Item>
                    : ""
                  }

                </Pagination>
              </div>
             }
            </Col>
           
          </Row>
         
        </Container>
      </div>
    );
  }
}

export default PublicEventPagingLayout;